import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import tiketsub from "@frameworks/web/assets/images/features/Ticketportal/ticketsub.svg";
import upload from "@frameworks/web/assets/images/features/BasicProfile/upload.svg";
import { fileuploadContent, fileuploadContentmb, } from "./constant";
import loader from "@frameworks/web/assets/images/generic/gifLoader.gif";
import EdModal from "@frameworks/web/components/generic/edModal";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import MaxSize from "@frameworks/web/assets/images/features/Ticketportal/MaxSize.svg";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useDispatch, useSelector } from "react-redux";
import mainDi from "@di";
import getScrollTop from "@frameworks/web/components/generic/customHooks/getScrollTop";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { useNavigate } from "react-router-dom";
import Attchedfileupload from "./common/Attchedfileupload";
import di from "./di/servicelocator";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
const NewTicket = (props) => {
    const navigate = useNavigate();
    const [resetFileUpload, setResetFileUpload] = useState(false);
    const [finalSizeExceed, setfinalSizeExceed] = React.useState(false);
    const [finalCheck, setFinalCheck] = React.useState(false);
    const [ticketLost, setTicketLost] = React.useState(false);
    const [submitFlag, setSubmitFlag] = React.useState(false);
    const [submitTicket, setSubmitTicket] = React.useState(false);
    const [maxSizeAlert, setMaxSizeAlert] = React.useState(false);
    const [fileInfo, setFileInfo] = React.useState(undefined);
    const [totalFileSize, setTotalFileSize] = React.useState(0);
    const [totalAttachment, setTotalAttachment] = React.useState(0);
    const [description, setDescription] = React.useState("");
    const [countcharcter, setCountCharcter] = React.useState(0);
    const [CloseAttachement, setCloseAttachement] = React.useState(false);
    const [ticketSubmitFail, setticketSubmitFail] = React.useState(false);
    const device = DeviceContext();
    const dispatch = useDispatch();
    const topValue = getScrollTop();
    React.useEffect(() => {
        mainDi.header.RemoveHeaderData(false);
        dispatch(mainDi.footer.setShowFooterUi(false));
        if (document.body.clientHeight + topValue === document.body.scrollHeight) {
            dispatch(mainDi.footer.updateShowMob_Menu(false));
        }
        else {
            dispatch(mainDi.footer.updateShowMob_Menu(false));
        }
    }, [topValue]);
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    React.useEffect(() => {
        if (props.submitFlag)
            submitHandler();
    }, [props.submitFlag]);
    const getFileInfo = (file) => {
        setFileInfo(file);
    };
    React.useEffect(() => {
        if (totalFileSize > 0) {
            if (device.isDesktop) {
                props.getTotalFileSize(totalFileSize);
                if (totalFileSize > 5120) {
                    setMaxSizeAlert(true);
                }
            }
        }
    }, [totalFileSize]);
    React.useEffect(() => {
        if (device && device.isDesktop)
            props.getDescription(description);
    }, [description]);
    React.useEffect(() => {
        if (device && device.isDesktop)
            props.getTotalAttachment(totalAttachment);
    }, [totalAttachment]);
    React.useEffect(() => {
        if (device && device.isDesktop)
            props.getCounter(countcharcter);
    }, [countcharcter]);
    React.useEffect(() => {
        if (submitFlag) {
            if (device.isDesktop)
                props.changeSubmitFlag(submitFlag);
        }
    }, [submitFlag]);
    React.useEffect(() => {
        totalFileSizeCalculation(fileInfo);
    }, [fileInfo]);
    const totalFileSizeCalculation = (files) => {
        var _a, _b, _c, _d;
        if (files && files.length > 0) {
            let totalFileSize = 0;
            for (let i = 0; i < files.length; i++) {
                let tempSize;
                if ((_b = (_a = files[i]) === null || _a === void 0 ? void 0 : _a.filesize) === null || _b === void 0 ? void 0 : _b.includes("KB")) {
                    tempSize = Number(files[i].filesize.split("KB")[0]);
                }
                else if ((_d = (_c = files[i]) === null || _c === void 0 ? void 0 : _c.filesize) === null || _d === void 0 ? void 0 : _d.includes("MB")) {
                    tempSize = Number(files[i].filesize.split("MB")[0]) * 1024;
                }
                totalFileSize = Number(totalFileSize) + Number(tempSize);
            }
            setTotalFileSize(totalFileSize);
            setTotalAttachment(files.length);
        }
    };
    const submitHandler = () => {
        const filenames = [];
        const filesBase64 = [];
        fileInfo.forEach((element) => {
            filenames.push(element.filename);
        });
        fileInfo.forEach((element) => {
            filesBase64.push(element.fileimage.split(",")[1]);
        });
        const payload = {
            description: description,
            arrFileName: filenames,
            arrBase64document: filesBase64,
        };
        di.ticketData.createTicketData(payload);
    };
    const submitTicketError = useSelector((state) => state.ticketPortal.CreateDataReducer.errorData);
    const createTicketData = useSelector((state) => state.ticketPortal.CreateDataReducer.data);
    const createTicketLoader = useSelector((state) => state.ticketPortal.CreateDataReducer.createTicketLoader);
    return (React.createElement(React.Fragment, null,
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(Row, { className: "mx-0" },
                React.createElement(Col, { lg: 12 },
                    React.createElement("span", { className: "DMSanBold_24_700 txt-blue-dark1" }, "New Ticket")),
                React.createElement(Col, { lg: 12, className: "mgt-30" },
                    React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 d-flex" }, "Description"),
                    React.createElement("div", { className: "main-textarea" },
                        React.createElement("textarea", { className: `textarea-common mgt-15 ${countcharcter >= 1000 ? "is-invalid" : "isvalid"}`, placeholder: "Please provided details of your issue", onChange: (e) => {
                                setDescription(e.target.value);
                                setCountCharcter(e.target.value.length);
                            } }),
                        React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey words-letter" },
                            countcharcter,
                            "/1000 words")),
                    countcharcter >= 1000 && (React.createElement(React.Fragment, null,
                        React.createElement(ErrorExclamation, { errorMessage: " Word Limit Exceeded", avoidBackground: true, parentClass: "ticketerror-msg" })))),
                React.createElement(Col, { lg: 12, className: "mgt-45" },
                    React.createElement(Attchedfileupload, { imagename: upload, fileuploadname: fileuploadContent, getFileInfo: getFileInfo }))))) : (React.createElement(React.Fragment, null,
            React.createElement(Row, { className: "mx-0 newticket-section px-0 bg-white commonscroll-new height750  pb-5" },
                React.createElement(Col, { lg: 12, className: "d-flex align-items-center" },
                    React.createElement("span", { className: "newticket-back", onClick: () => {
                            navigate("/ticket-portal");
                        } },
                        React.createElement("i", { className: "edel-icon-arrow-left1" })),
                    React.createElement("span", { className: "DMSansMedium_20_500 txt-blue-dark1 ps-2" }, "New Ticket")),
                React.createElement(Col, { lg: 12, className: "mgt-30" },
                    React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 d-flex" }, "Description"),
                    React.createElement("div", { className: "main-textarea" },
                        React.createElement("textarea", { className: `textarea-common mgt-15 ${countcharcter >= 1000 ? "is-invalid" : "isvalid"}`, placeholder: "Please provided details of your issue", onChange: (e) => {
                                setDescription(e.target.value);
                                setCountCharcter(e.target.value.length);
                            } }),
                        React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey words-letter" },
                            countcharcter,
                            "/1000 words")),
                    countcharcter >= 1000 && (React.createElement(React.Fragment, null,
                        React.createElement(ErrorExclamation, { errorMessage: " Word Limit Exceeded", avoidBackground: true, parentClass: "ticketerror-msg" })))),
                React.createElement(Col, { lg: 12, className: "mgt-45" },
                    React.createElement(Attchedfileupload, { imagename: upload, fileuploadname: fileuploadContentmb, getFileInfo: getFileInfo }))),
            React.createElement("div", { className: "bottom-contents topboxsshadow-button" },
                React.createElement(Row, { className: "bottombtnsection" },
                    React.createElement(Col, { lg: 6, xs: 6, className: "ps-3" },
                        React.createElement(EdButton, { btnTyp: "white-twenty", value: "Discard", className: "small-edbutton blood-red-border px-0 w-100", onClick: () => setTicketLost(true) })),
                    React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", className: "w-100", onClick: () => {
                                totalFileSizeCalculation(fileInfo);
                                if (totalFileSize > 5120) {
                                    setFinalCheck(false);
                                    setfinalSizeExceed(true);
                                }
                                else {
                                    setFinalCheck(true);
                                    setfinalSizeExceed(false);
                                }
                            }, disabled: !description || countcharcter >= 1000 || totalAttachment > 5 })))))),
        finalSizeExceed || (totalFileSize && maxSizeAlert) ? (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: true, setShow: setfinalSizeExceed, showFooter: false, title: "Maximum attachment size exceeded", modalTitle: `commonmodal gray-modal`, size: "modal-lg-660 modal-dialog-centered" },
                React.createElement(React.Fragment, null,
                    React.createElement(Row, { className: "d-flex justify-content-center" },
                        React.createElement(Col, { lg: 12, className: "px-5 grid-2-maxexceed" },
                            React.createElement("span", null,
                                React.createElement("img", { src: MaxSize })),
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1" }, "File Size too big. Total size of all attachments shouldn\u2019t exceed 5MB.")),
                        React.createElement(Col, { lg: 12, className: "mgt-40 px-5 pb-3" },
                            React.createElement(Row, null,
                                React.createElement(Col, { lg: 12, className: "text-center" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Ok", className: "w-60", onClick: () => {
                                            setfinalSizeExceed(false);
                                            setMaxSizeAlert(false);
                                            if (!device.isDesktop)
                                                setTotalFileSize(0);
                                        } }))))))))) : (React.createElement(React.Fragment, null,
            React.createElement(GenericDrawer, { show: finalSizeExceed, setShow: setfinalSizeExceed, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "File size too big")), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement(Row, { className: "d-flex justify-content-center pb-3 pt-3" },
                        React.createElement(Col, { lg: 12, className: "px-5" },
                            React.createElement("span", { className: "d-flex justify-content-center" },
                                React.createElement("img", { src: MaxSize })),
                            React.createElement("span", { className: "DMSan_14_500 txt_blackOne1 d-flex mgt-10 justify-content-center text-center commonlineheight-mb" }, "File Size too big. Total size of all attachments shouldn\u2019t exceed 5MB.")))) }))))) : (React.createElement(React.Fragment, null)),
        !finalSizeExceed && finalCheck && (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
            " ",
            React.createElement(GenericDrawer, { show: finalCheck, setShow: setFinalCheck, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1 ps-3 pb-3" }, "Final Check")), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "pb-2 height175 commonscroll-new" },
                            React.createElement(Row, { className: "d-flex justify-content-center mx-0" },
                                React.createElement(Col, { lg: 12, className: "p-4" },
                                    React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1" }, "Please ensure you\u2019ve captured all the details and uploaded necessary attachments in your ticket. You will not be able to make any changes once the ticket is submitted."))),
                            React.createElement(Row, { className: "bottom-contents topboxsshadow-button mx-0 pb-4 pt-4" },
                                React.createElement(Col, { lg: 6, className: "col-6" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Check Again", className: "w-100 px-0", onClick: () => {
                                            setFinalCheck(false);
                                        } })),
                                React.createElement(Col, { lg: 6, className: "col-6" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit Ticket", className: "w-100 px-0", onClick: () => {
                                            submitHandler();
                                            setFinalCheck(false);
                                            setSubmitTicket(true);
                                        } })))))) }))))),
        ticketLost && (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
            React.createElement(GenericDrawer, { show: ticketLost, setShow: setTicketLost, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Warning")), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "pb-2 height175 commonscroll-new" },
                        React.createElement(Row, { className: "d-flex justify-content-center mx-0" },
                            React.createElement(Col, { lg: 12, className: "p-4" },
                                React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1" }, "Data in new ticket will be lost if you view other ticket"))),
                        React.createElement(Row, { className: "bottom-contents topboxsshadow-button mx-0" },
                            React.createElement(Col, { lg: 6, className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Discard New Ticket", className: "w-100 px-0", onClick: () => {
                                        navigate("/ticket-portal");
                                    } })),
                            React.createElement(Col, { lg: 6, className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Continue Editing", className: "w-100 px-0", onClick: () => setTicketLost(false) }))))) }))))),
        device && !device.isDesktop && createTicketLoader && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "overlay-mb" },
                React.createElement(Row, { className: "mx-0  aligncenteritem" },
                    React.createElement(Col, { lg: 12, className: "" },
                        React.createElement("div", { className: "d-flex justify-content-center" },
                            React.createElement("img", { src: loader, className: "loader-height" })),
                        React.createElement("p", { className: "DMSan_14_700 txt_blackOne1 mgt-50 d-flex justify-content-center" }, "Submitting Ticket")))))),
        device &&
            !device.isDesktop &&
            createTicketData &&
            createTicketData.message &&
            navigate("/ticket-portal"),
        device &&
            !device.isDesktop &&
            submitTicketError &&
            submitTicketError.isOpen && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "overlay-mb" },
                React.createElement(Row, { className: "mx-0  aligncenteritem height400" },
                    React.createElement(Col, { lg: 12, className: "" },
                        React.createElement("div", { className: "d-flex justify-content-center" },
                            React.createElement("img", { src: tiketsub })),
                        React.createElement("p", { className: "DMSan_14_700 txt_blackOne1 mgt-20 d-flex justify-content-center" }, "Ticket submission failed due to a technical issue"),
                        React.createElement("p", { className: "text-center" },
                            React.createElement("span", { className: "edel-icon-refresh  ps-2" }),
                            React.createElement("span", { className: "ps-2 DMSan_14_700 txt-midnight-blue hand_cursor", onClick: () => {
                                    setSubmitFlag(false);
                                    navigate("/ticket-portal");
                                    location.reload();
                                } }, "Retry")))))))));
};
export default NewTicket;
